module.exports = __webpack_public_path__ + "img/major-list-button.fe0cc51.png";